module.exports = __webpack_public_path__ + "static/media/partner-6.220273d2.png";